import { Alert, Box, Paper, Typography } from "@mui/material"
import dayjs from "dayjs"
import Table from "../../Table"
import { formatCount } from "./UsageTable"
import EnterpriseMetricTooltip from "./EnterpriseMetricTooltip"

const planColumns = (accounts) => [
    { field: "name", headerName: "Plano", flex: 1, minWidth: 180 },
    { field: "total", headerName: "Contas", type: "number", width: 120, renderCell: ({ row, value }) => <EnterpriseMetricTooltip
        enterprises={accounts.filter(account => account.plan_id === row.id)} title="Contas">{formatCount(value)}</EnterpriseMetricTooltip> },
    { field: "suspended", headerName: "Suspensas", type: "number", width: 130, renderCell: ({ row, value }) => <EnterpriseMetricTooltip
        enterprises={accounts.filter(account => account.plan_id === row.id && account.is_suspended)} title="Contas suspensas">{formatCount(value)}</EnterpriseMetricTooltip> },
]

const accountColumns = [
    { field: "name", headerName: "Conta", flex: 1, minWidth: 200 },
    { field: "plan_name", headerName: "Plano", flex: 1, minWidth: 180 },
    { field: "is_suspended", headerName: "Situação", width: 150, valueGetter: ({ value }) => value ? "Suspensa" : "Sem suspensão" },
    { field: "created_at", headerName: "Cadastro", width: 140, valueFormatter: ({ value }) => value ? dayjs(value).format("DD/MM/YYYY") : "—" },
]

const ScoutSummary = ({ data }) => {
    if (!data)
        return null

    return (
        <Box sx={{ borderTop: "1px solid #E2E2E2", pt: 3, display: "flex", flexDirection: "column", gap: 2, minWidth: 0 }}>
            <Typography variant="h5">Scout self-service</Typography>
            <Typography variant="body2" color="text.secondary">
                Resumo consolidado no D-1 das contas com plano self-service, separado dos indicadores de empresas.
                Inclui cadastros ativos, sem a marcação de teste, inclusive suspensos.
                Os filtros de empresa e período acima não alteram este resumo.
            </Typography>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                {[["Contas Scout self-service", data.total, data.accounts], ["Contas suspensas", data.suspended, data.accounts.filter(account => account.is_suspended)]].map(([label, value, accounts]) => (
                    <Paper key={label} variant="outlined" sx={{ p: 2, borderRadius: 2, minWidth: 180 }}>
                        <Typography variant="body2" color="text.secondary">{label}</Typography>
                        <Typography variant="h4" sx={{ mt: 1, color: "#21446C" }}><EnterpriseMetricTooltip enterprises={accounts} title={label} emptyText="Nenhuma conta neste indicador.">{formatCount(value)}</EnterpriseMetricTooltip></Typography>
                    </Paper>
                ))}
            </Box>
            {!data.total
                ? <Alert severity="info">Nenhuma conta Scout self-service encontrada.</Alert>
                : <>
                    <Typography variant="h6">Contas por plano</Typography>
                    <Box sx={{ overflowX: "auto" }}>
                        <Table rows={data.plans} columns={planColumns(data.accounts)} pageSize={10} pagination toolbarFilter={false} />
                    </Box>
                    <Typography variant="h6">Contas Scout self-service</Typography>
                    <Box sx={{ overflowX: "auto" }}>
                        <Table rows={data.accounts} columns={accountColumns} pageSize={10} pagination toolbarFilter={false} />
                    </Box>
                </>}
        </Box>
    )
}

export default ScoutSummary
